export default {
  data() {
    return {
      minimapElementMap: null,
      minimapDragging: false
    }
  },
  computed: {
    minimapCornerRadius() {
      return Math.min(this.width, this.height) * 0.05
    }
  },
  methods: {
    renderMinimap() {
      if (!this.svgRoot || !this.$refs.minimapContent) return

      const clone = this.svgRoot.cloneNode(true)
      clone.removeAttribute('class')

      const origIdEls = Array.from(this.svgRoot.querySelectorAll('[id]'))
      const cloneIdEls = Array.from(clone.querySelectorAll('[id]'))

      this.minimapElementMap = new Map()
      origIdEls.forEach((el, i) => {
        const id = el.getAttribute('id')
        const clonedEl = cloneIdEls[i]
        if (id && clonedEl) {
          this.minimapElementMap.set(id, clonedEl)
          clonedEl.removeAttribute('id')
        }
      })

      this.$refs.minimapContent.innerHTML = ''
      Array.from(clone.childNodes).forEach(node => {
        this.$refs.minimapContent.appendChild(node)
      })

      this.syncMinimapState()
    },
    syncMinimapState() {
      if (!this.minimapElementMap) return

      this.minimapElementMap.forEach((clonedEl, id) => {
        const origEl = document.getElementById(id)
        if (!origEl) return

        if (origEl.classList.contains('unavailable')) {
          clonedEl.classList.add('unavailable')
        } else {
          clonedEl.classList.remove('unavailable')
        }

        if (this.selectedElements.includes(id)) {
          clonedEl.setAttribute('stroke', this.selectionColor)
          clonedEl.setAttribute('stroke-width', '8')
        } else {
          clonedEl.removeAttribute('stroke')
          clonedEl.removeAttribute('stroke-width')
        }
      })
    },
    mirrorSelectionState(id) {
      if (!this.minimapElementMap) return
      const clonedEl = this.minimapElementMap.get(id)
      if (!clonedEl) return

      if (this.selectedElements.includes(id)) {
        clonedEl.setAttribute('stroke', this.selectionColor)
        clonedEl.setAttribute('stroke-width', '8')
      } else {
        clonedEl.removeAttribute('stroke')
        clonedEl.removeAttribute('stroke-width')
      }
    },
    mirrorUnavailableState(id) {
      if (!this.minimapElementMap) return
      const clonedEl = this.minimapElementMap.get(id)
      const origEl = document.getElementById(id)
      if (!clonedEl || !origEl) return

      if (origEl.classList.contains('unavailable')) {
        clonedEl.classList.add('unavailable')
      } else {
        clonedEl.classList.remove('unavailable')
      }
    },
    minimapPointerToWorld(clientX, clientY) {
      const svgEl = this.$refs.minimapSvg
      const rect = svgEl.getBoundingClientRect()
      const ratioX = (clientX - rect.left) / rect.width
      const ratioY = (clientY - rect.top) / rect.height
      return { x: ratioX * this.worldWidth, y: ratioY * this.worldHeight }
    },
    moveViewportTo(worldX, worldY) {
      this.targetX = worldX - this.targetWidth / 2
      this.targetY = worldY - this.targetHeight / 2
      this.clampTarget()
      this.x = this.targetX
      this.y = this.targetY
      this.updateSvgViewBox()
    },
    startMinimapDrag(e) {
      if (e.cancelable) e.preventDefault()
      this.minimapDragging = true
      if (this.$refs.minimapWrapper) {
        this.$refs.minimapWrapper.classList.add('is-dragging')
      }
      this.onMinimapDrag(e)

      window.addEventListener('mousemove', this.onMinimapDrag)
      window.addEventListener('mouseup', this.endMinimapDrag)
      window.addEventListener('touchmove', this.onMinimapDrag, { passive: false })
      window.addEventListener('touchend', this.endMinimapDrag)
    },
    onMinimapDrag(e) {
      if (!this.minimapDragging) return
      if (e.cancelable) e.preventDefault()

      const pointer = this.getPointer(e)
      const world = this.minimapPointerToWorld(pointer.x, pointer.y)
      this.moveViewportTo(world.x, world.y)
    },
    endMinimapDrag() {
      this.minimapDragging = false
      if (this.$refs.minimapWrapper) {
        this.$refs.minimapWrapper.classList.remove('is-dragging')
      }
      window.removeEventListener('mousemove', this.onMinimapDrag)
      window.removeEventListener('mouseup', this.endMinimapDrag)
      window.removeEventListener('touchmove', this.onMinimapDrag)
      window.removeEventListener('touchend', this.endMinimapDrag)
    },
  },
  beforeUnmount() {
    this.endMinimapDrag()
  }
}
